import React, { useState } from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { useGetProductsQuery } from '../../store/api/productsApi';

function ProductAutocomplete({ onSelect, label = "Search Product...", variant = "outlined", sx = {} }) {
  const [search, setSearch] = useState('');
  const { data: products, isLoading } = useGetProductsQuery({ search });

  return (
    <Autocomplete
      fullWidth
      options={products?.products || []}
      getOptionLabel={(option) => `${option.name} (${option.sku || 'No SKU'})`}
      loading={isLoading}
      onInputChange={(event, newInputValue) => {
        setSearch(newInputValue);
      }}
      onChange={(event, newValue) => {
        if (onSelect) onSelect(newValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant={variant}
          sx={sx}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      renderOption={(props, option) => (
        <li {...props} key={option.id}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontWeight: 600 }}>{option.name}</span>
            <span style={{ fontSize: '0.75rem', color: 'gray' }}>
              SKU: {option.sku || 'N/A'} | Brand: {option.brand || 'N/A'}
            </span>
          </div>
        </li>
      )}
    />
  );
}

export default ProductAutocomplete;
